import type { OnDestroy, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import type * as Rx from 'rxjs';
import { MemoryLeakTracking } from './memory-leak-tracking.class';
import { MemoryTracking } from './memory-tracking.service';

@Component({
  selector: 'fl-memory-tracking',
  template: ` <ng-container></ng-container> `,
})
export class MemoryTrackingComponent implements OnInit, OnDestroy {
  private memoryTrackingSub?: Rx.Subscription;

  constructor(private memoryTracking: MemoryTracking) {}

  ngOnInit() {
    if (window.webapp) {
      window.webapp.memoryLeakTracking = new MemoryLeakTracking();
    }

    if (!window.performance?.memory) {
      return;
    }

    this.memoryTrackingSub = this.memoryTracking.monitor().subscribe();
  }

  ngOnDestroy() {
    this.memoryTrackingSub?.unsubscribe();
  }
}
